import { useRequiredContext } from "@redotech/react-util/context";
import { LoadState, useLoad } from "@redotech/react-util/load";
import { InteractiveMapLocation } from "@redotech/redo-model/draft-return/draft-return";
import { RpcClientContext } from "../../contexts/rpc";

export interface ReturnBearLocationsResponse {
  locationsLoad: LoadState<InteractiveMapLocation[]>;
}

export const useReturnBearLocations = (
  draftReturnId: string | undefined,
  returnId?: string | undefined,
): ReturnBearLocationsResponse => {
  const client = useRequiredContext(RpcClientContext);
  const locationsLoad: LoadState<InteractiveMapLocation[]> =
    useLoad(async () => {
      if (!draftReturnId && !returnId) {
        return [];
      }
      const { locations } = await client.getReturnBearLocations({
        draftReturnId,
        returnId,
      });
      return locations;
    }, [draftReturnId, returnId, client]);

  return { locationsLoad };
};
